import { SearchParams } from 'location.types'
import { validateEmail } from 'utils/validators'

export const getValidEmailFromSearchParams = (searchParams: URLSearchParams) =>
  searchParams
    .getAll(SearchParams.Email)
    .map((value) => value.trim().toLowerCase())
    .find((value) => value && validateEmail(value))
